import { ROUTING_MEASURES } from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const ResponseRateQuery: CubeQuery = {
  name: 'ResponseRate',
  query: {
    measures: [
      ROUTING_MEASURES.ROUTING_REQUEST_TO_TEAMMATE_ROUTED_IN,
      ROUTING_MEASURES.TEAMMATE_ROUTED_IN_TO_RESPONDED_WITHIN60S,
    ],
  },
  queryName: ROUTING_MEASURES.TEAMMATE_ROUTED_IN_TO_RESPONDED_WITHIN60S,
}
